import React, { Component } from 'react';
import { Container, Title } from './tourdates.css';
import Date from './date/date';
import axios from 'axios';

const API_KEY = 'qwcYowYaFS5P9AHk';
const ARTIST_ID = '8623349';

class TourDates extends Component {
  state = {
    hasLoaded: false,
    dates: [],
  };

  componentDidMount() {
    axios
      .get(
        `https://api.songkick.com/api/3.0/artists/${ARTIST_ID}/calendar/managed_performances.json?apikey=${API_KEY}&per_page=all`
      )
      .then(data => {
        this.setState({
          dates: [...data.data.resultsPage.results.performance],
          hasLoaded: true,
        });
      });
  }

  render() {
    const { hasLoaded, dates } = this.state;
    return (
      <Container name="tour" id="tour">
        <Title>Tour Dates</Title>
        {hasLoaded && dates.map(date => <Date key={date.id} {...date} />)}
        {/* {hasLoaded && dates.map(date => <div key={date.id}>{date.id}</div>)} */}
      </Container>
    );
  }
}

export default TourDates;
